var a;!function(a){a.default="default-node"}(a||(a={}));var d="id",t="[data-id]";export{t as NODE_SELECTOR,d as NODE_SELECTOR_DATASET_ID_ATTRIBUTE,a as NodeType};
